import { useCallback } from 'react'

/**
 * Creates the handleSave function with all necessary dependencies
 * @param {Object} params - Object containing required state setters and API functions
 * @returns {Function} The handleSave callback function
 */
export const createHandleSave = ({
  setIsSaving,
  setHasUnsavedChanges,
  setIsSaved,
  template_content,
  template_id_deprecated,
  navigate,
  projectAPI,
  templateAPI,
  showErrorDialog
}) => {
  return useCallback(async () => {
    try {
      const urlParams = window.location.pathname.split('/')
      const template_id = urlParams[urlParams.length - 1]
      setIsSaving(true)
      console.log('🔍 urlParams:', urlParams)
      console.log('🔍 Save Handler - URL template ID:', template_id)

      // For save API, only send template_content (template config)
      const saveData = {
        id: template_id,
        template_content: template_content
      }

      let response
      if (template_id) {
        // Update existing template - use templates/save API which only saves template_content
        console.log('✅ Saving template with ID:', template_id)
        response = await templateAPI.save(saveData)
        console.log('✅ Template saved successfully:', response.data)
      } else {
        // Create new template - use templates/save API
        // response = await templateAPI.save(saveData)
        // const newId = response.data.data.id
        // settemplate_id(newId)

        // // Update URL to include the new template ID
        // navigate(`/editor/${newId}`, { replace: true })

        // Show error dialog for missing template ID
        console.error('❌ No template ID found - template_content.id:', template_content?.id, 'template_id:', template_id)
        if (showErrorDialog) {
          showErrorDialog({
            title: "Cannot Save Configuration",
            message: "Template configuration cannot be saved because the Template ID is missing. Please contact support for assistance.",
            showContactInfo: true
          })
        } else {
          // Fallback to alert if dialog function not provided
          alert("Template configuration cannot be saved: Missing template_id. Please contact support.")
        }
      }

      setHasUnsavedChanges(false)
      setIsSaved(true)
      console.log('Template saved successfully')
    } catch (error) {
      console.error('Error saving template:', error)
      alert('Error saving template. Please try again.')
    } finally {
      setIsSaving(false)
    }
  }, [
    setIsSaving,
    setHasUnsavedChanges,
    setIsSaved,
    template_content,
    template_id_deprecated,
    navigate,
    projectAPI,
    templateAPI,
    showErrorDialog
  ])
}
